<template>
  <div class="teacher_data">
    <!-- Start Main Loader -->
    <transition name="fadeInUp" mode="out-in" v-if="loading">
      <MainLoader />
    </transition>
    <!-- End Main Loader -->
    <div class="personal_data_wrapper fadeIn" v-else>
      <NotFound v-if="rows.length == 0" text="لا يوجد متابعين"></NotFound>
      <div class="row" v-else>
        <div class="col-lg-4">
          <div class="input_wrapper top_label only_read my-2">
            <label class="form-label">{{
              $t("forms.labels.followers_count")
            }}</label>
            <input
              type="text"
              class="form-control"
              v-model.trim="userInfo.followers_count"
              readonly
            />
          </div>
        </div>

        <!-- Start:: Filter -->
        <UsersFilter title="المتابعين" @filterData="filterTable" />
        <!-- End:: Filter -->

        <div class="col-md-12">
          <div class="row">
            <!-- START:: SINGLE USER -->
            <div class="col-lg-3" v-for="user in rows" :key="user.id">
              <div class="follows_wrapper custom_card profile_card my-2">
                <router-link
                  :to="`/users/show/${user.id}`"
                  class="user_link profile_card_component"
                >
                  <div class="user_image icon">
                    <img :src="user.avatar" :alt="user.username" />
                  </div>
                  <div class="user_info">
                    <h4>{{ user.username }}</h4>
                    <h5>{{ user.fullname }}</h5>
                  </div>
                </router-link>
              </div>
            </div>
            <!-- START:: SINGLE USER -->
          </div>
        </div>

        <!-- Start Pagination -->
        <template>
          <div class="pagination_container tw-text-center mb-5">
            <v-pagination
              circle
              v-model="paginations.current_page"
              :length="paginations.last_page"
              :total-visible="6"
            ></v-pagination>
          </div>
        </template>
        <!-- End Pagination -->

        <!-- ban_reason -->
      </div>
    </div>
  </div>
</template>
<script>
import UsersFilter from "@/components/Filters/UsersFilter.vue";

export default {
  props: ["userInfo", "id"],

  data() {
    return {
      data: {},
      // ========== Your Data
      rows: [], // injected in created

      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 20,
      },
      // ========== filterItems
      filterItems: null,
      loading: false,
      // ========== Statistics
      statisticsItem: {},
    };
  },

  components: {
    UsersFilter,
  },

  watch: {
    [`paginations.current_page`]() {
      this.setRows();
    },
  },

  methods: {
    // ===== Search Method =====
    filterClick(word) {
      if (!this.loading) {
        this.search = word;
        this.helper_filterSearch();
      }
    },
    // Filter Table
    filterTable(items) {
      this.rows = [];
      this.filterItems = items;
      this.setRows();
    },
    // Set Rows
    setRows() {
      this.loading = true;
      this.axios({
        method: "GET",
        url: `client/${this.id}/followers`,
        params: {
          page: this.paginations.current_page,
          text: this.filterItems ? this.filterItems.text : null,
          user_id: this.filterItems ? this.filterItems.user_id : null,
        },
      })
        .then((res) => {
          this.paginations.last_page = res.data.meta.last_page;
          this.paginations.items_per_page = res.data.meta.per_page;

          this.rows = res.data.data;

          this.statisticsItem.number = res.data.meta.total;

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.setRows();
  },
};
</script>

<style></style>
